





































































import isImage from 'is-image-url'
import { Component, Prop, Vue } from 'vue-property-decorator'
import CardInput from '@/components/CardInput/index.vue'
import CardInner from '@/components/CardInner/index.vue'
import Drag from './drag.vue'
import isUrl from 'is-url'
import {
  YELLOW,
  YELLOW_DARK,
  BLUE,
  BLUE_DARK,
  RED,
  RED_DARK,
  SELECT,
  OFFWHITE
} from '../color'
import {
  DRAG_WIDTH,
  PADDING,
  UNIT,
  CANVAS_WIDTH,
  CANVAS_HEIGHT,
  BORDER_WIDTH,
  CARD_WIDTH
} from '@/components/numbers'
import {
  isYoutube,
  isTwitter,
  isTable,
  isOrderedList,
  isHeadline,
  getHeadlineHeight
} from '@/components/utils'

@Component<Card>({
  components: {
    CardInput,
    CardInner,
    Drag
  },
  watch: {
    initial(newVal, oldVal) {
      if (oldVal.x !== newVal.x || oldVal.y !== newVal.y) {
        this.rerender()
      }
    },
    value(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.$nextTick(() => {
          this.matchBoundRect()
          this.rerender()
        })
      }
    },
    html(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.$nextTick(() => {
          this.matchBoundRect()
          this.rerender()
        })
      }
    }
  }
})
export default class Card extends Vue {
  @Prop()
  public diff!: { x: number; y: number }
  @Prop()
  public movingId!: string | undefined
  @Prop()
  public selected!: boolean
  @Prop()
  public disabled!: boolean
  @Prop()
  private id!: string
  @Prop({ default: '' })
  private value!: string
  @Prop()
  private color!: string
  @Prop()
  private initial!: { x: number; y: number }
  @Prop()
  private html!: string
  @Prop()
  private url!: string

  @Prop()
  private handleMove!: (x: number, y: number, id: string) => void
  @Prop()
  private handleStop!: () => void
  @Prop()
  private handleStart!: (id: string) => void
  @Prop()
  private handleUpdate!: (id: string, value: string) => void
  @Prop()
  private handleRemove!: (id: string) => void
  @Prop()
  private handleSelect!: (id: string) => void
  @Prop()
  private handleURL!: (url: string, id: string) => void

  private show: boolean = true
  private editing: boolean = false
  private x: number = this.initial.x
  private y: number = this.initial.y
  private width: number = 0
  private height: number = 0
  private selectColor: string = SELECT

  private DRAG_WIDTH = DRAG_WIDTH
  private UNIT = UNIT
  private CANVAS_WIDTH = CANVAS_WIDTH
  private CANVAS_HEIGHT = CANVAS_HEIGHT
  private BORDER_WIDTH = BORDER_WIDTH

  private isImage = isImage
  private isYoutube = isYoutube
  private isTwitter = isTwitter
  private isTable = isTable

  private mounted() {
    this.matchBoundRect()
    if (this.id === 'new') {
      this.editing = true
    }
  }

  private matchBoundRect(): void {
    const el = this.$refs.card as Element
    this.height = el.clientHeight + DRAG_WIDTH * 2 + BORDER_WIDTH * 2
    this.width = el.clientWidth + DRAG_WIDTH * 2 + BORDER_WIDTH * 2
  }

  private rerender(): void {
    this.show = false
    this.x = this.initial.x
    this.y = this.initial.y
    this.$nextTick(() => {
      this.show = true
    })
  }

  private stopEvent(e: MouseEvent): void {
    e.stopPropagation()
  }

  private submit(value: string): void {
    if (!value) {
      this.handleRemove(this.id)
      return
    }
    this.handleUpdate(this.id, value)
  }

  private onClick() {
    this.editing = true
    this.handleSelect(this.id)
  }

  private blur() {
    this.editing = false
  }

  private onImageMeasure(width: number, height: number) {
    this.height =
      Math.round(height / 2) + DRAG_WIDTH * 2 + PADDING * 2 + BORDER_WIDTH * 2
    this.width =
      Math.round(width / 2) + DRAG_WIDTH * 2 + PADDING * 2 + BORDER_WIDTH * 2
  }

  private onHTMLMeasure(ratio: number, defaultHeight: number) {
    this.height =
      defaultHeight +
      (CARD_WIDTH - PADDING * 2 - BORDER_WIDTH * 2) * ratio +
      DRAG_WIDTH * 2 +
      PADDING * 2 +
      BORDER_WIDTH * 2
  }

  private onDragging(x: number, y: number): void {
    if (!this.movingId) {
      this.handleStart(this.id)
    }
    const diffX = this.x - x - DRAG_WIDTH
    const diffY = this.y - y - DRAG_WIDTH
    this.x = x + DRAG_WIDTH
    this.y = y + DRAG_WIDTH
    this.handleMove(diffX, diffY, this.id)
  }

  private onURL(url: string) {
    this.handleURL(url, this.id)
  }

  private getType({
    value,
    html,
    url,
    color
  }: {
    value: string
    html: string
    url: string
    color: string
  }): string {
    return html && url === value
      ? 'webpage'
      : this.isImage(value)
      ? 'image'
      : this.isYoutube(value)
      ? 'youtube'
      : this.isTwitter(value)
      ? 'twitter'
      : isUrl(value)
      ? 'url'
      : this.isTable(value)
      ? 'table'
      : isOrderedList(value)
      ? 'list'
      : isHeadline(value, color)
      ? 'headline'
      : ''
  }

  private getColor(): {
    'background-color': string
    'border-color': string
  } {
    return {
      'background-color':
        this.color === 'red'
          ? RED
          : this.color === 'blue'
          ? BLUE
          : this.color === 'yellow'
          ? YELLOW
          : this.color === 'offwhite'
          ? OFFWHITE
          : '',
      'border-color':
        this.color === 'red'
          ? RED_DARK
          : this.color === 'blue'
          ? BLUE_DARK
          : this.color === 'yellow'
          ? YELLOW_DARK
          : ''
    }
  }
}
